var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7518_376974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 14.625H9.0075M17.1048 6.52557C14.9697 4.56899 12.1242 3.375 8.99991 3.375C5.87561 3.375 3.03017 4.56899 0.89502 6.52557M3.54895 9.18223C5.00254 7.90174 6.91055 7.125 8.99998 7.125C11.0894 7.125 12.9974 7.90174 14.451 9.18223M11.7737 11.8313C11.0094 11.2322 10.0464 10.875 8.99991 10.875C7.93762 10.875 6.96129 11.2431 6.19153 11.8587",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7518_376974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.41a16b6649909e940898ceb2c00e2284.svg";
export { ForwardRef as ReactComponent };